
<template>
  <Modal
    :id="'cmp-royalty-contracts-edit_deductions_modal'"
    @cancelled="onCancel"
  >
    <template slot="header">{{
      deductions_target == "deduction4"
        ? $t("contract_deduction_2")
        : $t("contract_deduction_1")
    }}</template>
    <template slot="body">
      <div class="form-group" :class="{
        'dt-loading': loading
      }">
        <div>
          <div class="dt-checkbox-control">
            <div class="dt-checkbox v2">
              <input
                disabled
                type="checkbox"
                :name="'digital'"
                :id="'digital'"
                :checked="contract_deduction.digital_flag == 1"
              />
              <div class="checkmark"></div>
            </div>
            <div class="dt-checkbox-label">{{ $t("digital") }}</div>
          </div>
          <div class="dt-checkbox-control">
            <div class="dt-checkbox v2">
              <input
                disabled
                type="checkbox"
                :name="'physical'"
                :id="'physical'"
                :checked="contract_deduction.physical_flag == 1"
              />
              <div class="checkmark"></div>
            </div>
            <div class="dt-checkbox-label">{{ $t("physical") }}</div>
          </div>
        </div>
        <TextField
          :id="'sequence'"
          class="m1"
          v-bind="textFieldConfig"
          :value="`${contract_deduction.sequence}`"
          :placeholder="$t('sequence')"
          @valuechanged="onTextFieldValueChange"
          required
          showValidationIcons
          @validated="onValidation"
        />
        <TextField
          :id="'name'"
          class="m1"
          v-bind="textFieldConfig"
          :value="contract_deduction.name"
          :placeholder="$t('name')"
          @valuechanged="onTextFieldValueChange"
          required
          showValidationIcons
          @validated="onValidation"
        />
        <TextField
          :id="'percentage'"
          class="m1"
          v-bind="textFieldConfig"
          :value="contract_deduction.percentage"
          :placeholder="$t('deduction_per')"
          @valuechanged="onTextFieldValueChange"
          required
          showValidationIcons
          @validated="onValidation"
        />

        <Dropdown
          :id="'territory'"
          class="m2"
          :options="territoriesTV"
          deselect
          :selected="
            territoriesTV.find(
              (e) => e.value == contract_deduction.territory_id
            )
          "
          :placeholder="$t('territory')"
          box
          @selectedChange="(e) => onDropdownChange('territory_id', e)"
        ></Dropdown>

        <Dropdown
          :id="'account'"
          class="m2"
          deselect
          isSearchable
          @searched="onAccountSearch"
          :options="accountsTV"
          :selected="
            accountsTV.find((e) => e.value == contract_deduction.account_id)
          "
          :placeholder="$t('account')"
          box
          @selectedChange="(e) => onDropdownChange('account_id', e)"
        ></Dropdown>
        <Dropdown
          v-if="!digitalPhysical"
          :id="'shop_group_id'"
          class="m2"
          deselect
          :options="shop_groupsTV"
          :selected="
            shop_groupsTV.find(
              (e) => e.value == contract_deduction.shop_group_id
            )
          "
          :placeholder="$t('shop_group')"
          box
          @selectedChange="(e) => onDropdownChange('shop_group_id', e)"
        ></Dropdown>
        <Dropdown
          v-if="
            contract_deduction.physical_flag == 1 &&
            contract_deduction.digital_flag == 0
          "
          :id="'format_group'"
          class="m2"
          deselect
          :options="format_groupsTV"
          :selected="
            format_groupsTV.find(
              (e) => e.value == contract_deduction.format_group
            )
          "
          :placeholder="$t('format_group')"
          box
          @selectedChange="(e) => onDropdownChange('format_group', e)"
        ></Dropdown>
        <Dropdown
          :id="'product_group_id'"
          class="m2"
          deselect
          :options="product_groupsTV"
          :selected="
            product_groupsTV.find(
              (e) => e.value == contract_deduction.product_group_id
            )
          "
          :placeholder="$t('product_group')"
          box
          @selectedChange="(e) => onDropdownChange('product_group_id', e)"
        ></Dropdown>

        <Dropdown
          :id="'release_id'"
          class="m2"
          deselect
          isSearchable
          @searched="onReleaseSearch"
          :options="releasesTV"
          :selected="
            releasesTV.find((e) => e.value == contract_deduction.release_id)
          "
          :placeholder="$t('release')"
          box
          @selectedChange="(e) => onDropdownChange('release_id', e)"
        ></Dropdown>

        <Dropdown
          :id="'product_id'"
          class="m2"
          deselect
          :options="productsTV"
          isSearchable
          @searched="onProductSearch"
          :selected="
            productsTV.find((e) => e.value == contract_deduction.product_id)
          "
          :placeholder="$t('product')"
          box
          @selectedChange="(e) => onDropdownChange('product_id', e)"
        ></Dropdown>
        <TextField
          v-if="
            contract_deduction.physical_flag == 1 &&
            contract_deduction.digital_flag == 0
          "
          :id="'ppd_ratio'"
          class="m1"
          :showValidationIcons="false"
          :type="'number'"
          v-bind="textFieldConfig"
          :value="contract_deduction.ppd_ratio"
          :placeholder="$t('income_ppd_ratio')"
          @valuechanged="onTextFieldValueChange"
        />
        <div
          style="
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            justify-content: flex-start;
            gap: 10px;
          "
        >
          <TextField
            style="width: 100%"
            :id="'age'"
            class="m1"
            :showValidationIcons="false"
            :type="'number'"
            v-bind="textFieldConfig"
            :value="contract_deduction.age"
            :placeholder="$t('age_at_date_of_sales')"
            @valuechanged="onTextFieldValueChange"
          />
          <Dropdown
            v-if="!digitalPhysical"
            style="width: 100%"
            :id="'age_base'"
            class="m2"
            deselect
            :options="age_monthTV"
            :selected="
              age_monthTV.find((e) => e.value === contract_deduction.age_base)
            "
            :placeholder="$t('age month')"
            box
            @selectedChange="(e) => onDropdownChange('age_base', e)"
          ></Dropdown>
        </div>
        <TextField
          :id="'start_date'"
          class="m1"
          :type="'date'"
          :value="contract_deduction.start_date"
          :placeholder="$t('start_date')"
          @valuechanged="onTextFieldValueChange"
        />
        <TextField
          :id="'end_date'"
          class="m1"
          :type="'date'"
          :value="contract_deduction.end_date"
          :placeholder="$t('end_date')"
          @valuechanged="onTextFieldValueChange"
        />
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $dft.snakeCaseToWords("cancel") }}
      </button>
      <button class="dt-button v1 s6" @click.stop="onAdd">
        {{ $dft.snakeCaseToWords("ok") }}
      </button>
    </template>
  </Modal>
</template>
  
<script>
import Modal from "../../../../dt-plugins/modal/modal";
import { openModalRoute } from "../../../../dt-plugins/modal/modal.mixin";
import { ContractsService } from "../../services/contracts.service";
import { createTV } from "../../../../models/text-value.model";
import { EventHooks } from "../../../../plugins/text-field";
import { Subject } from "rxjs";
import { subscribeSubject } from "../../../../utility";
export default {
  components: {
    Modal,
  },

  data: () => ({
    accountSubject$: new Subject(),
    releaseSubject$: new Subject(),
    productSubject$: new Subject(),
    royaltyLicencingNr: { ro: {} },
    selectedItemValue: null,
    selectedItem: null,
    deductionData: null,
    loading: false,
    contract_deduction: {
      account_id: 0,
      account_name: "",
      age: "",
      age_base: "",
      catalog_no: "",
      contract_deduction_id: "",
      contract_id: "",
      created: "",
      deduction_target: "",
      digital_flag: "",
      end_date: "",
      format_group: "",
      last_modified: "",
      name: "",
      percentage: "",
      physical_flag: "",
      ppd_ratio: "",
      product_group_id: "",
      product_id: "",
      release_id: "",
      release_name: "",
      sequence: "",
      shop_group_id: "",
      start_date: "",
      territory_id: "",
    },
    validationResult: {},
    textFieldConfig: {
      height: 42,
      showEditIconOnHover: false,
      box: true,
      showValidationIcons: true,
      immediateValidation: true,
      validationEvent: EventHooks.OnKeyup,
      isModel: true,
    },
  }),

  mounted: async function () {
    this.loading = true;
    const res = await ContractsService.addEditDeductionModalData(
      this.contract_deduction_id
    );
    this.deductionData = res.data;
    this.contract_deduction = {
      ...this.deductionData.contract_deduction,
    };
    this.loading = false;
    this.deductionData = {
      ...this.deductionData,
      accounts: [
        {
          account_id: this.contract_deduction.account_id,
          account_name: this.contract_deduction.account_name,
        },
      ],
      releases: [
        {
          release_id: this.contract_deduction.release_id,
          release_name: this.contract_deduction.release_name,
        },
      ],
      products: [
        {
          product_id: this.contract_deduction.product_id,
          identifier: this.contract_deduction.catalog_no,
        },
      ],
    };

    subscribeSubject(this, this.accountSubject$, (searchString) => {
      ContractsService.searchContractDeductionAccounts(searchString).then(
        (res) => {
          this.deductionData = {
            ...this.deductionData,
            accounts: res.data.accounts,
          };
        }
      );
    });
    subscribeSubject(this, this.productSubject$, (searchString) => {
      ContractsService.searchContractDeductionProducts(searchString).then(
        (res) => {
          this.deductionData = {
            ...this.deductionData,
            products: res.data.products,
          };
        }
      );
    });
    subscribeSubject(this, this.releaseSubject$, (searchString) => {
      ContractsService.searchContractDeductionReleases(searchString).then(
        (res) => {
          this.deductionData = {
            ...this.deductionData,
            releases: res.data.releases,
          };
        }
      );
    });
  },
  computed: {
    isFormValid: function () {
      return Object.values(this.validationResult).every((e) => e.valid);
    },
    digitalPhysical: function () {
      return (
        this.contract_deduction.physical_flag == 1 &&
        this.contract_deduction.digital_flag == 1
      );
    },
    contract_deduction_id: function () {
      return this.$route.query.contract_deduction_id;
    },
    deductions_target: function () {
      return this.$route.query.deductions_target;
    },
    contract_id: function () {
      return this.$route.params.contract_id;
    },
    product_groupsTV: function () {
      return createTV(
        this.deductionData?.product_groups,
        "product_group_name1",
        "product_group_id"
      );
    },
    format_groupsTV: function () {
      return (
        this.deductionData?.format_groups.map((format) => {
          return {
            text: format,
            value: format,
          };
        }) || []
      );
    },
    shop_groupsTV: function () {
      return createTV(
        this.deductionData?.shop_groups,
        "shop_group_name",
        "shop_group_id"
      );
    },
    territoriesTV: function () {
      return createTV(
        this.deductionData?.territories,
        "territory_name",
        "territory_id"
      );
    },
    accountsTV: function () {
      return createTV(
        this.deductionData?.accounts,
        "account_name",
        "account_id"
      );
    },
    releasesTV: function () {
      return createTV(
        this.deductionData?.releases,
        "release_name",
        "release_id"
      );
    },
    productsTV: function () {
      return createTV(this.deductionData?.products, "identifier", "product_id");
    },
    channelsTV: function () {
      return [
        { text: this.$t("on_digital_only"), value: "on_digital_only" },
        { text: this.$t("on_physical_only"), value: "on_physical_only" },
        { text: this.$t("on_digital_physical"), value: "on_digital_physical" },
      ];
    },
    age_monthTV: function () {
      return [
        { text: "Month", value: "MONTH" },
        { text: "Week", value: "WEEK" },
        { text: "Day", value: "DAY" },
      ];
    },
  },
  methods: {
    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },
    onAddClick: function (e) {
      openModalRoute(this, e, {
        mode: "add",
      });
    },
    onAdd: async function () {
      this.contract_deduction.contract_id = this.contract_id;
      this.contract_deduction.deduction_target = this.deductions_target;
      const res = await ContractsService.saveContractDeduction({
        ...this.contract_deduction,
        contract_deduction_id: this.contract_deduction_id,
      });
      this.$emit("added", { deductions_target: this.deductions_target });
    },
    onReportItemAdded(e) {
      this.selectedItem = {
        ...e,
      };
    },
    onTextFieldValueChange(name, value) {
      this.contract_deduction[name] = value;
    },
    onAccountSearch: function (searchTerm) {
      console.log("Search works", searchTerm);
      this.accountSubject$.next(searchTerm);
    },
    onProductSearch: function (searchTerm) {
      console.log("Search works", searchTerm);
      this.productSubject$.next(searchTerm);
    },
    onReleaseSearch: function (searchTerm) {
      console.log("Search works", searchTerm);
      this.releaseSubject$.next(searchTerm);
    },
    onChannelDropdownChange(value) {
      this.showForm = true;
      if (value.value === "on_digital_only") {
        this.contract_deduction["digital_flag"] = 1;
        this.contract_deduction["physical_flag"] = 0;
      } else if (value.value === "on_physical_only") {
        this.contract_deduction["digital_flag"] = 0;
        this.contract_deduction["physical_flag"] = 1;
      } else if (value.value === "on_digital_physical") {
        this.contract_deduction["digital_flag"] = 1;
        this.contract_deduction["physical_flag"] = 1;
      }
    },
    onDropdownChange(name, value) {
      this.contract_deduction[name] = value.value;
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
  },
};
</script>
  
<style lang="scss" scoped>
.cmp-royalty-contracts-edit_deductions_modal {
  .body-container {
    max-height: 460px;
    // padding-right: 30px;
    overflow: hidden;
    overflow-y: auto;
    width: 100%;
    .dt-modal--subtitle {
      &:first-child {
        margin-top: 0;
      }
    }
  }
  .dt-checkbox-control {
    align-items: center;
    height: 32px;
    .dt-checkbox-label {
      flex: 1;
      padding-left: 10px;
    }
  }
  .item-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .s6 {
      margin: 10px;
    }
  }

  .dt-modal--options {
    button {
      &:first-child {
        margin-right: 10px;
      }

      &:last-child {
        margin-left: 0px 10px;
      }
    }
  }
}
</style>
  